import { Apple, Play, Download } from 'lucide-react'
import { FadeIn } from '../components/ui/FadeIn'
import { useLanguage } from '../contexts/LanguageContext'

export function DownloadsSection() {
  const { t } = useLanguage()

  return (
    <section id="descargas" className="relative">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
        <FadeIn>
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6 sm:p-8 text-center">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Download className="size-5 text-nexus-blue" />
              <h3 className="text-lg font-semibold tracking-tight">{t('downloads.title')}</h3>
            </div>
            <p className="text-sm text-white/70 mb-6 max-w-2xl mx-auto">
              {t('downloads.description')}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#appstore"
                className="inline-flex items-center gap-3 rounded-xl px-6 py-3 bg-white/10 hover:bg-white/15 border border-white/10 transition-colors"
              >
                <Apple className="size-6 text-white" />
                <div className="text-left">
                  <div className="text-[10px] text-white/60">{t('downloads.appstore')}</div>
                  <div className="text-sm font-semibold">App Store</div>
                </div>
              </a>
              <a
                href="#playstore"
                className="inline-flex items-center gap-3 rounded-xl px-6 py-3 bg-white/10 hover:bg-white/15 border border-white/10 transition-colors"
              >
                <Play className="size-6 text-white" />
                <div className="text-left">
                  <div className="text-[10px] text-white/60">{t('downloads.playstore')}</div>
                  <div className="text-sm font-semibold">Play Store</div>
                </div>
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  )
}

